<template>
  <!-- Filtros de codificación rejas - componente reutilizable -->
  <div v-if="isRejas" class="w-full">

    <div class="border-t border-grey-light pt-4 mt-2 mb-4">
      <span class="text-sm font-bold text-grey-dark">{{ $t('codification_filters') }}</span>
    </div>

    <!-- Año, Codificador, Revisión -->
    <div class="flex w-full flex-col lg:flex-row gap-4 mb-4">
      <b-field :label="$t('year')" class="w-full">
        <b-select v-model="filters.rejas_year" :placeholder="$t('all')" expanded @input="emitFilters">
          <option :value="null">{{ $t('all') }}</option>
          <option v-for="i in tyearValues" :value="i.value" :key="'rfty_'+i.value">
            {{ i.name }}
          </option>
        </b-select>
      </b-field>

      <b-field :label="$t('documents')" class="w-full">
        <b-select v-model="filters.rejas_codificador" :placeholder="$t('all')" expanded @input="onCodificadorChange">
          <option :value="null">{{ $t('all') }}</option>
          <option value="planos">{{ $t('codificador_planos') }}</option>
          <option value="resto">{{ $t('codificador_resto') }}</option>
        </b-select>
      </b-field>

      <b-field :label="$t('revision')" class="w-full">
        <b-select v-model="filters.rejas_revision" :placeholder="$t('all')" expanded @input="emitFilters">
          <option :value="null">{{ $t('all') }}</option>
          <option v-for="letter in abecedary" :value="letter" :key="'rfrev_'+letter">
            R{{ letter }}
          </option>
        </b-select>
      </b-field>
    </div>

    <!-- PLANOS -->
    <div v-if="filters.rejas_codificador === 'planos'" class="flex w-full flex-col lg:flex-row gap-4 mb-4">
      <b-field :label="$t('discipline')" class="w-full">
        <b-select v-model="filters.rejas_c1_disciplina" :placeholder="$t('all')" expanded @input="emitFilters">
          <option :value="null">{{ $t('all') }}</option>
          <option v-for="item in c1Disciplinas" :key="'rfc1d_'+item.code" :value="item.code">
            {{ item.code }} - {{ item.description }}
          </option>
        </b-select>
      </b-field>

      <b-field :label="$t('document_type')" class="w-full">
        <b-select v-model="filters.rejas_c1_tipo_documento" :placeholder="$t('all')" expanded @input="emitFilters">
          <option :value="null">{{ $t('all') }}</option>
          <option v-for="item in c1TiposDocumento" :key="'rfc1td_'+item.code" :value="item.code">
            {{ item.code }} - {{ item.description }}
          </option>
        </b-select>
      </b-field>
    </div>

    <!-- RESTO -->
    <div v-if="filters.rejas_codificador === 'resto'" class="flex w-full flex-col lg:flex-row gap-4 mb-4">
      <b-field :label="$t('creator')" class="w-full">
        <b-select v-model="filters.rejas_c2_creador" :placeholder="$t('all')" expanded @input="emitFilters">
          <option :value="null">{{ $t('all') }}</option>
          <option v-for="item in c2Creadores" :key="'rfc2cr_'+item.code" :value="item.code">
            {{ item.code }} - {{ item.description }}
          </option>
        </b-select>
      </b-field>

      <b-field :label="$t('document_type')" class="w-full">
        <b-select v-model="filters.rejas_c2_tipo_documento" :placeholder="$t('all')" expanded @input="emitFilters">
          <option :value="null">{{ $t('all') }}</option>
          <option v-for="item in c2TiposDocumento" :key="'rfc2td_'+item.code" :value="item.code">
            {{ item.code }} - {{ item.description }}
          </option>
        </b-select>
      </b-field>

      <b-field :label="$t('discipline')" class="w-full">
        <b-select v-model="filters.rejas_c2_disciplina" :placeholder="$t('all')" expanded @input="emitFilters">
          <option :value="null">{{ $t('all') }}</option>
          <option v-for="item in c2Disciplinas" :key="'rfc2di_'+item.code" :value="item.code">
            {{ item.code }} - {{ item.description }}
          </option>
        </b-select>
      </b-field>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import {
  c1Disciplinas, c1TiposDocumento,
  c2Creadores, c2TiposDocumento, c2Disciplinas,
  abecedary, getYearValues,
} from './rejas-config'

const EMPTY_FILTERS = {
  rejas_year: null,
  rejas_codificador: null,
  rejas_revision: null,
  rejas_c1_disciplina: null,
  rejas_c1_tipo_documento: null,
  rejas_c2_creador: null,
  rejas_c2_tipo_documento: null,
  rejas_c2_disciplina: null,
}

export default {
  name: 'rejas-filters',

  props: {
    value: { type: Object, default: null },
  },

  data() {
    return {
      filters: { ...EMPTY_FILTERS },
      c1Disciplinas,
      c1TiposDocumento,
      c2Creadores,
      c2TiposDocumento,
      c2Disciplinas,
      abecedary,
      tyearValues: [],
    }
  },

  computed: {
    ...mapGetters({
      project: 'app/project',
    }),

    isRejas() {
      return this.project && this.project.codification_form === 'rejas'
    },
  },

  created() {
    if (this.isRejas) {
      this.tyearValues = getYearValues(moment)
    }
    if (this.value) {
      this.filters = { ...EMPTY_FILTERS, ...this.value }
    }
  },

  methods: {
    emitFilters() {
      this.$emit('input', this.hasActiveFilters() ? { ...this.filters } : null)
    },

    onCodificadorChange() {
      // Al cambiar de planos<->resto, limpiar los campos del codificador anterior
      this.filters.rejas_c1_disciplina = null
      this.filters.rejas_c1_tipo_documento = null
      this.filters.rejas_c2_creador = null
      this.filters.rejas_c2_tipo_documento = null
      this.filters.rejas_c2_disciplina = null
      this.emitFilters()
    },

    hasActiveFilters() {
      const f = this.filters
      return !!(f.rejas_year || f.rejas_codificador || f.rejas_revision
        || f.rejas_c1_disciplina || f.rejas_c1_tipo_documento
        || f.rejas_c2_creador || f.rejas_c2_tipo_documento || f.rejas_c2_disciplina)
    },

    /** Resetea todos los filtros. El padre lo llama al pulsar "Limpiar filtros" */
    clean() {
      this.filters = { ...EMPTY_FILTERS }
      this.emitFilters()
    },

    /** Devuelve los filtros activos. Lo lee el padre vía $refs al generar los parámetros */
    getFilters() {
      return this.hasActiveFilters() ? { ...this.filters } : null
    },
  },
}
</script>
